import { v1 as uuidv1 } from 'uuid';

const CDN_URL = "https://dtyw1lw4i4r2x.cloudfront.net/";
const CDN_URL_ASSETS = CDN_URL + "banners/";

const urlParams = new URLSearchParams(window.location.search);
// window.utm = {
const tracking_code = urlParams.get('utm_content') ? urlParams.get('utm_content') : (uuidv1());
const compaign_name = urlParams.get('utm_campaign') ? urlParams.get('utm_campaign') : "";
const medium = urlParams.get('utm_medium') ? urlParams.get('utm_medium') : "Khaleef";
const isFantasy = urlParams.get('isFantasy') ? urlParams.get('isFantasy') : 0;
// subscriptionNo: urlParams.get("subscriptionNo")
// }
const countries = ["pk"];
const languages = ["en", "ur"];
const telcos = ["jc", "tp", "ep", "all", "jazz"];
const configs = ["jc", "tp", "ep", "all", "jazz", "jazz_fantasy", "tp_fantasy", "billed", "all_telcos", "telenorPK",  "pinFlow"];
const allPaths = window.location.pathname.split("/")

export const getCDNUrl = (filename) => {
  return CDN_URL_ASSETS + filename
}
export const getTrackingCode = () => {
  return tracking_code;
}
export const getUTMMediun = () => {
  return medium;
}
export const getDefaultLanding = () => {
  return isFantasy;
}
export const getLastPathItem = thePath => {
  return thePath && thePath.substring(thePath.lastIndexOf('/') + 1)
}

export const getAllPathsInUrl = (url) => {
  return allPaths;
}


export const findCaseInsensitive = (array, value) => {
  return array.find(item => value.toLowerCase() === item.toLowerCase());
}
export const getUserLanguage = () => {
  for (let j = 0; j < languages.length; j++) {
    const item = findCaseInsensitive(allPaths, languages[j]);
    if (item) {
      return item;
    }
  }
  return "en";
}
export const getUserCountry = () => {
  //return array.length >= 3 ? (!array[2].toLowerCase() ? "pk" : array[2].toLowerCase()) : "pk";
  for (let j = 0; j < countries.length; j++) {
    const item = findCaseInsensitive(allPaths, countries[j]);
    if (item) {
      return item;
    }
  }
  return "pk";
}
export const getUserConfigs = () => {
  //return array.length >= 3 ? (!array[2].toLowerCase() ? "pk" : array[2].toLowerCase()) : "pk";
  for (let j = 0; j < configs.length; j++) {
    const item = findCaseInsensitive(allPaths, configs[j]);
    if (item) {
      return item;
    }
  }
  return "tp";
}

/*export const getUserTelco = () => {
  //return array.length >= 3 ? (!array[2].toLowerCase() ? "pk" : array[2].toLowerCase()) : "pk";
  for (let j = 0; j < telcos.length; j++) {
    const item = findCaseInsensitive(allPaths, telcos[j]);
    if (item) {
      return item;
    }
  }
  return "tp";
}*/

export const getMatchedValue = (array, value, defalt) => {
  for (let i = 0; i < array.length; i++) {
    for (let j = 0; j < value.length; j++) {
      if (array[i].toLowerCase() === value[j].toLowerCase())
        return value[j].toLowerCase();
    }
  }
  return defalt;
}
export const getMatchedItemFromResponse = (response, items) => {
  for (let i = 0; i < items.length; i++) {
    if (items[i] in response)
      return response[items[i]];
  }
}
export const saveUTMParams = async (payload, event_name, msisdn) => {
  let url = "https://k8s.cricwick.net/khaleef-attribution/api/v1/attributions/mark_event?event_name=" +
    event_name + "&compaign_id=" +
    getCompaignId() + "&tracking_code=" +
    tracking_code + "&compaign_name=" +
    compaign_name + "&medium=" +
    medium + "&msisdn=" + (msisdn);
  await fetch(url);
  // console.log(utmResponse);
}

export function getParametrByName(name) {
  var url_string = window.location.href;
  var url = new URL(url_string);
  var c = url.searchParams.get(name);

  return c ? c : "";
}

const getErrorObj = (message) => {
  return {
    status: false,
    message: message
  }
}

const getNumbervalidObj = (initial, prefix, number) => {
  console.log("initial is: " + initial);
  console.log("prefix is: " + prefix);
  console.log("number is: " + number);
  return {
    status: true,
    initial: initial,
    prefix: prefix,
    number: number
  }
}

const getCnicvalidObj = (last, prefix, cnic) => {
  console.log("last is: " + last);
  console.log("prefix is: " + prefix);
  console.log("cnic is: " + cnic);
  return {
    status: true,
    last: last,
    prefix: prefix,
    cnic: cnic
  }
}

export const validateCnicPK = (cnic) => {
  console.log("code is here");
  if (cnic.trim().length === 0) {
    return getErrorObj("Please enter Valid CNIC");
  }

  let msisdn = cnic;

  let last = msisdn.substr( -6);
  console.log("last is: " + last);

  let numero = msisdn.substring(2, 3);

  if (msisdn.length !== 13) {
    return getErrorObj("Please enter Valid CNIC");
  } else {
    return getCnicvalidObj(last, numero, msisdn);
  }

}

export const validateNumberPK = (number) => {
  console.log("code is here");
  if (number.trim().length === 0) {
    return getErrorObj("Please enter Valid number");
  }

  let msisdn = number;
  
  if (msisdn.substring(0, 6) === "009203") {
    msisdn = `03${msisdn.substring(6)}`;
  } else if (msisdn.substring(0, 5) === "00923") {
    msisdn = `03${msisdn.substring(5)}`;
  } else if (msisdn.substring(0, 4) === "0923") {
    msisdn = `03${msisdn.substring(4)}`;
  } else if (msisdn.substring(0, 4) === "9203") {
    msisdn = `03${msisdn.substring(4)}`;
  } else if (msisdn.substring(0, 3) === "923") {
    msisdn = `03${msisdn.substring(3)}`;
  } else if (msisdn.substring(0, 3) === "903") {
    msisdn = `03${msisdn.substring(3)}`;
  } else if (msisdn.substring(0, 2) === "03") {
    msisdn = `03${msisdn.substring(2)}`;
  } else if (msisdn.substring(0, 1) === "3") {
    msisdn = `03${msisdn.substring(1)}`;
  } else {
    return getErrorObj("Please enter Valid number");
  }

  let initial = msisdn.substring(0, 2);
  let numero = msisdn.substring(2, 3);

  if (msisdn.length !== 11) {
    return getErrorObj("Please enter Valid number");
  } else {
    return getNumbervalidObj(initial, numero, msisdn);
  }

}

export const validateNumberKW = (number) => {
  if (number.trim().length === 0) {
    return getErrorObj("Please enter Valid number");
  }

  let msisdn = number;

  if (msisdn.substring(0, 6) === "009650") {
    msisdn = `965${msisdn.substring(6)}`;
  } else if (msisdn.substring(0, 5) === "00965") {
    msisdn = `965${msisdn.substring(5)}`;
  } else if (msisdn.substring(0, 4) === "0965") {
    msisdn = `965${msisdn.substring(4)}`;
  } else if (msisdn.substring(0, 4) === "9650") {
    msisdn = `965${msisdn.substring(4)}`;
  } else if (msisdn.substring(0, 3) === "965") {
    msisdn = `965${msisdn.substring(3)}`;
  } else if (msisdn.substring(0, 1) === "0") {
    msisdn = `965${msisdn.substring(0)}`;
  } else if (msisdn.substring(0, 1) === "5") {
    msisdn = `965${msisdn.substring(0)}`;
  } else if (msisdn.substring(0, 1) === "6") {
    msisdn = `965${msisdn.substring(0)}`;
  } else if (msisdn.substring(0, 1) === "9") {
    msisdn = `965${msisdn.substring(0)}`;
  } else {
    return getErrorObj("Please enter Valid number");
  }

  let numero = msisdn.substring(3, 4);
  let initial = msisdn.substring(0, 3);

  if (msisdn.length !== 11) {
    return getErrorObj("Please enter Valid number");
  } else {
    return getNumbervalidObj(initial, numero, msisdn);
  }

}
const getDefaultUTM = () => {
  return "189";
}
export const ValidateUTMSource = () => {
  const utms = {
    "2": ["189", "191", "193", "194", "195", "196", "197", "200"],
    "10": ["65"],
    "11": ["66"]
  }
  let p_id = urlParams.get("partner_id") ? urlParams.get("partner_id") : "2"
  let utm_source = urlParams.get("utm_source") ? urlParams.get("utm_source") : getDefaultUTM();
  for (let i = 0; i < utms[p_id].length; i++) {
    let x = utms[p_id][i];
    if (x === utm_source)
      return true;
  }
  return false;
}
const getCompaignId = () => {
  return urlParams.get('utm_source') ? urlParams.get('utm_source') : getDefaultUTM();
}
export const saveChargedEvent = async (response, msisdn) => {
  if ("is_charged" in response && response["is_charged"] === 1) {
  await saveUTMParams({}, "charged", msisdn);
  }
}